export default __webpack_public_path__ + "static/media/3.a27f58c2.jpg";